export default [
    {
        "name": "NV Raghuramu",
        "batch": "1980",
        "department": "Electrical & Electronics Engineering",
        "photo": "Raghuramu.jpg"
    },
    {
        "name": "Kumar Govindrajpuram Vidyanathan",
        "batch": "1991",
        "department": "Mechanical Engineering",
        "photo": "Kumar Govindrajpuram.jpg"
    },
    {
        "name": "Sreekumar KT",
        "batch": "1991",
        "department": "Electronics & Communication Engineering",
        "photo": "Sreekumar.jpg",
        "amount": "10,000"
    },
    {
        "name": "Harinath Renukamurthy",
        "batch": "1991",
        "department": "ELectronics & Communication Engineering",
        "photo": "empty photo.jpg"
    },
    {
        "name": "Prashanth R Samaga",
        "batch": "1991",
        "department": "Electrical & Electronics Engineering",
        "photo": "Prashanth.jpg"
    },
    {
        "name": "Prasanna Koteshwara",
        "batch": "1991",
        "department": "Metallurgical Engineering",
        "photo": "empty photo.jpg"
    },
    {
        "name": "Prasanna Udupi",
        "batch": "1991",
        "department": "Electrical & Electronics Engineering",
        "photo": "Prasanna Udupi.jpg",
        "amount": "75,000"
    },
    {
        "name": "Sadanand Hegde",
        "batch": "1982",
        "department": "ELectronics & Communication Engineering",
        "photo": "Sadanand Hegde.jpg"
    },
    {
        "name": "Umesh Sangurmath",
        "batch": "1991",
        "department": "Electrical & Electronics Engineering",
        "photo": "empty photo.jpg",
        "amount": "1,00,000"
    },
    {
        "name": "Keshav Venkatraman Nayak",
        "batch": "1973",
        "department": "Mechanical Engineering",
        "photo": "KV Nayak.jpg",
    },
    {
        "name": "Late. Ajit Kadwadkar",
        "batch": "1979",
        "department": "Mechanical Engineering",
        "photo": "Ajit Kadwadkar.jpg",
    },
    {
        "name": "Ramamurthy Krishna",
        "batch": "1979",
        "department": "ELectronics & Communication Engineering",
        "photo": "Ramamurthy.jpg"
    },
    {
        "name": "Kandanadan",
        "batch": "2001",
        "department": "Civil Engineering",
        "photo": "empty photo.jpg",
    },
    {
        "name": "Praveen Rao",
        "batch": "1991",
        "department": "Mechanical Engineering",
        "photo": "empty photo.jpg",
    },
    {
        "name": "S C Balawat",
        "batch": "1972",
        "department": "Metallurgy Engineering",
        "photo": "empty photo.jpg",
    },
    {
        "name": "Anand Kumar",
        "batch": "2022",
        "department": "-",
        "photo": "empty photo.jpg",
    },
    {
        "name": "Ashok Rao",
        "batch": "1986",
        "department": "Mechanical Engineering",
        "photo": "empty photo.jpg",
    },
    {
        "name": "Gopal Bhupal",
        "batch": "1977",
        "department": "Metallurgy Engineering",
        "photo": "empty photo.jpg",
    },
    {
        "name": "Sreenivas Rao",
        "batch": "1965",
        "department": "Mechanical Engineering",
        "photo": "empty photo.jpg",
    },
    {
        "name": "Prashanth Kamath",
        "batch": "1995",
        "department": "Mechanical Engineering",
        "photo": "empty photo.jpg",
    },
    {
        "name": "Shailesh Gadad",
        "batch": "1993",
        "department": "Chemical Engineering",
        "photo": "empty photo.jpg",
    },
    {
        "name": "Prashanth Samaga",
        "batch": "1991",
        "department": "-",
        "photo": "empty photo.jpg",
    },
    {
        "name": "Pankaj Jain",
        "batch": "1991",
        "department": "Mechanical Engineering",
        "photo": "empty photo.jpg",
    },
    {
        "name": "Suresh Sreeniasaiah",
        "batch": "",
        "department": "-",
        "photo": "empty photo.jpg",
    }
]